import { useContext, useEffect } from 'react';
import SystemLibGeoBar from './geo-bar';
import './index.less';
import SystemLibMenuBar from './menu';
import SystemLibOperationBar from './operation-bar';
import { EngineContext, NavigationContext, RegisterContext } from '@/App';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { IconButton, Tab } from 'bimui';
import { ReactComponent as ClearSvg } from "bimui/dist/c1/icons/clear.svg"
import Draw from '../graphic/draw/draw';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { coreAxios } from '@/declare/api/axios';
import MainSidebar from '../sidebar';
import SystemLibHeader from './header';
import CodePanel from '../graphic/code';
import localStore from '@/store/local-store';



export default function SystemLibLayout() {

    const navigateContext = useContext(NavigationContext);
    const registerContext = useContext(RegisterContext);
    const engineContext = useContext(EngineContext);
    const navigate = useNavigate();
    const routeParams = useParams();

    useEffect(() => {
        localStore.activeMajor = "system-lib";
        registerContext.activeSidebar(null)
        return () => {
            localStore.clearProjectInfo();
            navigateContext.clearTabs();
            registerContext.activeSidebar(null);
            registerContext.activeTool(null);
        }
    }, [])

    /**
     * 清空标签页
     */
    const onClearTabs = () => {
        navigateContext.clearTabs();
        navigate(`/system-lib`);
    }

    return (
        <div className='system-lib-layout'>
            <SystemLibHeader />
            <SystemLibMenuBar />
            <div className="system-lib-tool">
                <SystemLibOperationBar />
                <SystemLibGeoBar emitCommand={engineContext.emitCommand} />
            </div>
            <div className='main'>
                <Routes>
                    <Route path='*' element={<MainSidebar />} />
                </Routes>
                <div className="view-panel">
                    <div className="tab-wrap">
                        <Tab tabs={navigateContext.tabs} activeKey={navigateContext.activeTabKey} onChange={(route) => {
                            if (route == null) {
                                // 说明没有页签了
                                registerContext.activeTool(null);
                                if (registerContext.sidebarPanels[registerContext.currentActivedSidebarKey] == null) {
                                    registerContext.activeSidebar(null);
                                }
                                navigate(`/system-lib`)
                                return;
                            }
                            navigateContext.setActiveTabKey(route);
                            navigate(route);
                        }} onClose={(key) => {
                            navigateContext.removeTab(key);
                        }} />
                        <div className="clear-icon"><IconButton icon={<ClearSvg />} onClick={onClearTabs}></IconButton></div>
                    </div>
                    <div className="view-container">
                        <Routes>
                            <Route path='formulas/:formulaId' element={<CodePanel />} />
                            {registerContext.routes.map(item =>
                                <Route path={item.path} element={<item.element {...engineContext}
                                    drawPanel={Draw}
                                    emitter={emitter}
                                    emitterType={Emit_Event_Common_Tool}
                                    registTab={(key: string, value: string) => {
                                        navigateContext.registTab({
                                            key: key,
                                            value: value,
                                        })
                                    }} activeTab={(key) => {
                                        navigateContext.setActiveTabKey(key)
                                    }} routeParams={routeParams}
                                    axios={coreAxios}
                                />} />
                            )}
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    )
}